export default __webpack_public_path__ + "static/media/pakistan---islamabad.fa266a08.jpeg";